<template>
  <div class="side-nav-skeleton">
    <div class="side-nav__placeholder"></div>
    <div class="side-nav__placeholder side-nav__placeholder--square"></div>
    <div v-for="el in 4" :key="el" class="side-nav__placeholder"></div>
  </div>
</template>

<style lang="scss">
@use '@/styles/utils';

.side-nav {
  &__placeholder {
    width: 100%;
    background: linear-gradient(
      75deg,
      ads.$ads-outline-low 15%,
      #c0bfc4 25%,
      ads.$ads-outline-low 45%
    );
    animation: placeHolderShimmer 4.5s linear infinite forwards;
    height: ads.$ads-spacing-scale-2xl;
    margin-bottom: ads.$ads-spacing-scale-2xl;
    border-radius: ads.$ads-border-radius-container-low;

    &--square {
      height: 60px;
      margin-bottom: ads.$ads-spacing-scale-4xl;
    }
  }
}
</style>
